<template>
  <div>
    <div class="tips">
      <span class="tips-text2">*{{ $t("message.messageMsg.shortCutKeyTips") }}</span>
    </div>
    <!-- 删除配置 -->
    <div class="first-box">
      <div class="title">{{ $t('message.hotKeysMsg.deleteConfiguration.title') }}</div>
      <el-row>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.deleteConfiguration.clearAllConfigurations') }}:</span>
          <el-select size="medium" v-model="s.DeleteConfig.delete_all">
            <el-option :label="$t('common.open')" :value="true"></el-option>
            <el-option :label="$t('common.close')" :value="false"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.deleteConfiguration.clearAllMappings') }}:</span>
          <el-select size="medium" v-model="s.DeleteConfig.delete_key_mapping_info">
            <el-option :label="$t('common.open')" :value="true"></el-option>
            <el-option :label="$t('common.close')" :value="false"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.deleteConfiguration.clearAllBroadcasts') }}:</span>
          <el-select size="medium" v-model="s.DeleteConfig.delete_broadcast_info">
            <el-option :label="$t('common.open')" :value="true"></el-option>
            <el-option :label="$t('common.close')" :value="false"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.deleteConfiguration.deletedesignatedBroadcast') }}:</span>
          <el-button type="text" @click="openDeleteBroadcastDialog">{{ $t('common.add') }}</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 广播信息 -->
    <div class="first-box">
      <div class="title">{{ $t('message.hotKeysMsg.configureBroadcast.title') }}</div>
      <el-row>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.configureBroadcast.addBroadcast') }}:</span>
          <el-button type="text" @click="openAddBroadcastDialog">{{ $t('common.add') }}</el-button>
        </el-col>
        <el-col :span="24" v-if="broadcastList.length">
          <div class="tags-box">
            <el-tag id="tag-box" v-for="(v, i) in broadcastList" :key="i" closable @close="deleteAddBroadcast(i)">
              {{ v.name?.length > 30 ? v.name?.substring(0, 29) + "..." : v.name }}
            </el-tag>
          </div>
          <!-- <el-table :data="broadcastList" border style="margin:10px 10px;">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="name" :label="$t('message.hotKeysMsg.configureBroadcast.broadcastName')"></el-table-column>
            <el-table-column prop="action" label="Action"></el-table-column>
            <el-table-column prop="package_name" label="Package Name"></el-table-column>
            <el-table-column prop="class_name" label="Class Name"></el-table-column>
            <el-table-column :label="$t('common.operation')">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="deleteAddBroadcast(scope.$index)">{{ $t('common.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table> -->
        </el-col>
      </el-row>
    </div>

    <!-- 按键映射 -->
    <div class="first-box">
      <div class="title">{{ $t('message.hotKeysMsg.keyValueMapping.title') }}</div>
      <el-row>
        <el-col :span="10" class="setting-box">
          <span class="setTitle">{{ $t('message.hotKeysMsg.keyValueMapping.addKeyValue') }}:</span>
          <el-button type="text" @click="openAddKeyMappingDialog">{{ $t('common.add') }}</el-button>
        </el-col>
        <el-col :span="24" v-if="keyMappingList.length">
          <div class="tags-box">
            <el-tag id="tag-box" v-for="(v, i) in keyMappingList" :key="i" closable @close="handleKeyMappingDelete(i)">
              {{ v.key }}:{{ v.type }}
            </el-tag>
          </div>
          <!-- <el-table :data="keyMappingList" border style="margin:10px 10px;">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="key" :label="$t('message.hotKeysMsg.keyValueMapping.enterPhysicalKey')">
              <template slot-scope="{ row }">
                <span>{{ originalKeyMappingLabel(row.key) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" :label="$t('message.hotKeysMsg.keyValueMapping.mappingType')">
              <template slot-scope="{ row }">
                <span v-if="row.type === 'BROADCAST'">{{ $t('message.hotKeysMsg.keyValueMapping.mappingBroadcast') }}</span>
                <span v-if="row.type === 'APPLICATION'">{{ $t('message.hotKeysMsg.keyValueMapping.mappingApp') }}</span>
                <span v-if="row.type === 'OTHER_KEYCODE'">{{ $t('message.hotKeysMsg.keyValueMapping.mappingOtherKey') }}</span>
                <span v-if="row.type === 'NONE'">{{ $t('message.hotKeysMsg.keyValueMapping.noMapping') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="virtual_key" :label="$t('message.hotKeysMsg.keyValueMapping.androidKeyValue')">
              <template slot-scope="{ row }">
                <span>{{ targetKeyMappingLabel(row.virtual_key) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="broadcast_name" :label="$t('message.hotKeysMsg.keyValueMapping.broadcastName')"></el-table-column>
            <el-table-column prop="package_name" :label="$t('message.hotKeysMsg.keyValueMapping.appPackageName')"></el-table-column>
            <el-table-column prop="class_name" :label="$t('message.hotKeysMsg.keyValueMapping.appClassName')"></el-table-column>
            <el-table-column :label="$t('common.operation')">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleKeyMappingDelete(scope.$index)">{{ $t('common.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table> -->
        </el-col>
      </el-row>
    </div>

    <!-- 删除指定广播 -->
    <el-dialog :title="$t('message.hotKeysMsg.deleteConfiguration.deletedesignatedBroadcast')" :visible.sync="deleteBroadcastDialogVisible" width="50%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-button type="text" icon="el-icon-circle-plus-outline" @click="addDeleteBroadcast">{{ $t("common.add") }}</el-button>
      <el-table border :data="deleteBroadcast">
        <el-table-column prop="id" :label="$t('common.index')" width="80" type="index" align="center" />
        <el-table-column prop="name" :label="$t('message.hotKeysMsg.deleteConfiguration.deleteBroadcastName')" align="center">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.name }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-circle-check" @click="okDeleteBroadcastItem(scope.row)" v-show="scope.row.isEdit">{{ $t('common.save') }}</el-button>
            <el-button type="text" icon="el-icon-edit" @click="editDeleteBroadcastItem(scope.row)" v-show="!scope.row.isEdit">{{ $t("common.edit") }}</el-button>
            <el-button type="text" icon="el-icon-delete" @click="delDeleteBroadcastItem(scope.row)" v-show="!scope.row.isEdit">{{ $t("common.delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-footer">
        <el-button @click="cancelDeleteBroadcast">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="saveDeleteBroadcast">{{ $t('common.submit') }}</el-button>
      </div>
    </el-dialog>

    <!-- 添加广播弹框 -->
    <el-dialog :title="$t('message.hotKeysMsg.configureBroadcast.addBroadcast')" :visible.sync="broadcastDialogVisible" width="60%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-width="150px" :rules="broadcastRules" :model="broadcastData" ref="addBroadcastForm" class="custom-form">
        <el-form-item :label="$t('message.hotKeysMsg.configureBroadcast.broadcastName')" prop="name">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="broadcastData.name"></el-input>
        </el-form-item>
        <el-form-item label="Action" prop="action">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="broadcastData.action"></el-input>
        </el-form-item>
        <el-form-item label="Package Name" prop="package_name">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="broadcastData.package_name"></el-input>
        </el-form-item>
        <el-form-item label="Class Name" prop="class_name">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="broadcastData.class_name"></el-input>
        </el-form-item>
        <!-- 参数列表 -->
        <div class="third-box">
          <div class="title">{{ $t('message.hotKeysMsg.configureBroadcast.parameter') }}</div>
          <el-button type="text" icon="el-icon-circle-plus-outline" @click="addParameter">{{ $t("common.add") }}</el-button>
          <el-table border :data="broadcastData.parameters">
            <el-table-column prop="id" :label="$t('common.index')" width="80" type="index" align="center" />
            <el-table-column prop="name" :label="$t('message.hotKeysMsg.configureBroadcast.name')" align="center">
              <template #default="scope">
                <span v-show="!scope.row.isEdit">{{ scope.row.name }}</span>
                <el-input v-show="scope.row.isEdit" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type" :label="$t('message.hotKeysMsg.configureBroadcast.type')" align="center">
              <template #default="scope">
                <span v-show="!scope.row.isEdit">{{ scope.row.type }}</span>
                <el-select v-show="scope.row.isEdit" v-model="scope.row.type">
                  <el-option label="String" value="String"></el-option>
                  <el-option label="Integer" value="Integer"></el-option>
                  <el-option label="Float" value="Float"></el-option>
                  <el-option label="Double" value="Double"></el-option>
                  <el-option label="Long" value="Long"></el-option>
                  <el-option label="Short" value="Short"></el-option>
                  <el-option label="Char" value="Char"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('message.hotKeysMsg.configureBroadcast.value')" align="center">
              <template #default="scope">
                <span v-show="!scope.row.isEdit">{{ scope.row.value }}</span>
                <el-input v-show="scope.row.isEdit" v-model="scope.row.value"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" align="center">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-circle-check" @click="okParameter(scope.row)" v-show="scope.row.isEdit">{{ $t('common.save') }}</el-button>
                <el-button type="text" icon="el-icon-edit" @click="editParameter(scope.row)" v-show="!scope.row.isEdit">{{ $t('common.edit') }}</el-button>
                <el-button type="text" icon="el-icon-delete" @click="removeParameter(scope.$index)" v-show="!scope.row.isEdit">{{ $t('common.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancelAddBroadcast">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="saveAddBroadcast">{{ $t('common.submit') }}</el-button>
      </div>
    </el-dialog>

    <!-- 添加按键映射弹框 -->
    <el-dialog :title="$t('message.hotKeysMsg.keyValueMapping.addKeyValue')" :visible.sync="keyMappingDialogVisible" width="50%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-alert :title="$t('message.messageMsg.keyMappingTips')" type="warning" :closable="false"></el-alert>
      <el-form label-width="180px" :rules="keyMappingRules" :model="keyMappingData" ref="addKeyMappingForm" class="custom-form">
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.enterPhysicalKey')" prop="key">
          <!-- <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.key"></el-input> -->
          <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.key" class="input-width-select">
            <el-select v-model="originalKey" filterable slot="prepend" :placeholder="$t('common.pleaseSelect')" @change="originalKeyMappingChange">
              <el-option v-for="(item, index) in originalKeyMapping" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.mappingType')" prop="type">
          <el-select v-model="keyMappingData.type" @change="onKeyMappingTypeChange">
            <el-option :label="$t('message.hotKeysMsg.keyValueMapping.mappingBroadcast')" value="BROADCAST"></el-option>
            <el-option :label="$t('message.hotKeysMsg.keyValueMapping.mappingApp')" value="APPLICATION"></el-option>
            <el-option :label="$t('message.hotKeysMsg.keyValueMapping.mappingOtherKey')" value="OTHER_KEYCODE"></el-option>
            <el-option :label="$t('message.hotKeysMsg.keyValueMapping.noMapping')" value="NONE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.androidKeyValue')" prop="virtual_key" v-if="keyMappingData.type === 'OTHER_KEYCODE'">
          <!-- <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.virtual_key"></el-input> -->
          <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.virtual_key" class="input-width-select">
            <el-select v-model="targetKey" filterable slot="prepend" :placeholder="$t('common.pleaseSelect')" @change="targetKeyMappingChange">
              <el-option v-for="(item, index) in targetKeyMapping" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.broadcastName')" prop="broadcast_name" v-if="keyMappingData.type === 'BROADCAST'">
          <el-select v-model="keyMappingData.broadcast_name" :placeholder="$t('common.pleaseSelect')">
            <el-option v-for="(broadcast, index) in broadcastList" :key="index" :label="broadcast.name" :value="broadcast.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.appPackageName')" prop="package_name" v-if="keyMappingData.type === 'APPLICATION'">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.package_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.hotKeysMsg.keyValueMapping.appClassName')" prop="class_name" v-if="keyMappingData.type === 'APPLICATION'" class="pre-wrap">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="keyMappingData.class_name"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancelAddKeyMapping">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="saveAddKeyMapping">{{ $t('common.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { originalKeyMapping, targetKeyMapping } from "@/utils/keyMapping"
export default {
  props: {
    shortCutKey: {
      type: Object,
      default: () => ({
        DeleteConfig: {
          BroadcastInfo: [],
        },
        BroadcastInfo: [],
        KeyMappingInfo: []
      })
    }
  },
  data() {
    return {
      broadcastDialogVisible: false,
      keyMappingDialogVisible: false,
      broadcastData: {
        name: '',
        action: '',
        package_name: '',
        class_name: '',
        parameters: []
      },
      keyMappingData: {
        key: '',
        type: '',
        virtual_key: '',
        broadcast_name: '',
        package_name: '',
        class_name: ''
      },
      deleteBroadcast: [],
      deleteBroadcastDialogVisible: false,
      originalKey: '',
      targetKey: '',
      originalKeyMapping: originalKeyMapping,
      targetKeyMapping: targetKeyMapping
    }
  },
  computed: {
    s() {
      return this.shortCutKey
    },
    broadcastList() {
      return this.s.BroadcastInfo || []
    },
    keyMappingList() {
      return this.s.KeyMappingInfo || []
    },
    broadcastRules() {
      return {
        name: [
          { required: true, message: this.$t('message.messageMsg.inputName'), trigger: 'blur' }
        ],
        // action: [
        //   { required: true, message: this.$t('message.messageMsg.inputAction'), trigger: 'blur' }
        // ],
        // package_name: [
        //   { required: true, message: this.$t('message.messageMsg.inputPackageName'), trigger: 'blur' }
        // ],
        // class_name: [
        //   { required: true, message: this.$t('message.messageMsg.inputClassName'), trigger: 'blur' }
        // ]
      }
    },
    keyMappingRules() {
      return {
        key: [
          { required: true, message: this.$t('message.messageMsg.inputKeyName'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('message.messageMsg.selectType'), trigger: 'blur' }
        ],
        virtual_key: [
          { required: true, message: this.$t('message.messageMsg.inputVirtualKey'), trigger: 'blur' }
        ],
        broadcast_name: [
          { required: true, message: this.$t('message.messageMsg.selectBroadcast'), trigger: 'blur' }
        ],
        package_name: [
          { required: true, message: this.$t('message.messageMsg.inputAppPackageName'), trigger: 'blur' }
        ],
        class_name: [
          { required: true, message: this.$t('message.messageMsg.inputAppClassName'), trigger: 'blur' }
        ]
      }
    },
  },
  watch: {
    s: {
      handler(newVal) {
        this.$emit('update:shortCutKey', newVal)
        this.$emit('update:config-shortcut-key', newVal)
      },
      deep: true
    }
  },
  methods: {
    // originalKeyMappingLabel(value) {
    //   const selected = this.originalKeyMapping.find(item => item.value === value)
    //   return selected ? selected.label : ''
    // },
    // targetKeyMappingLabel(value) {
    //   const selected = this.targetKeyMapping.find(item => item.value === value)
    //   return selected ? selected.label : ''
    // },
    originalKeyMappingChange(val) { 
      this.keyMappingData.key = val;
    },
    targetKeyMappingChange(val) { 
      this.keyMappingData.virtual_key = val;
    },
    /********** 删除指定广播-start ***********/
    // 打开删除指定广播弹框
    openDeleteBroadcastDialog() {
      this.deleteBroadcast = (this.s.DeleteConfig?.BroadcastInfo || []).map(item => ({
        name: item.name || '',
        isEdit: false
      }))
      this.deleteBroadcastDialogVisible = true
    },
    // 添加删除指定广播
    addDeleteBroadcast() {
      this.deleteBroadcast.push({
        name: '',
        isEdit: true
      })
    },
    // 取消删除指定广播
    cancelDeleteBroadcast() {
      this.deleteBroadcast = []
      this.deleteBroadcastDialogVisible = false
    },
    // 保存删除指定广播
    saveDeleteBroadcast() {
      // 检查是否有正在编辑的项
      if (this.deleteBroadcast.some(item => item.isEdit)) {
        this.$message.warning(this.$t('message.messageMsg.complateEdit'))
        return
      }
      // 过滤空名称，保持数组格式
      const validBroadcasts = this.deleteBroadcast
        .filter(item => item.name && item.name.trim() !== '')
        .map(item => ({ name: item.name.trim() }))

      // 保存到 DeleteConfig
      if (!this.s.DeleteConfig) {
        this.s.DeleteConfig = {}
      }
      this.s.DeleteConfig.BroadcastInfo = validBroadcasts

      this.$set(this.s, 'DeleteConfig', { ...this.s.DeleteConfig })

      this.deleteBroadcastDialogVisible = false
      this.$message.success(this.$t('common.save_success'))
    },
    // 编辑删除广播项
    editDeleteBroadcastItem(row) {
      row.isEdit = true
    },
    // 确认删除广播项
    okDeleteBroadcastItem(row) {
      if (row.name && row.name.trim() !== '') {
        row.isEdit = false
      } else {
        this.$message.warning(this.$t('message.messageMsg.inputBroadcastName'))
      }
    },
    // 删除删除广播项（表格内删除）
    delDeleteBroadcastItem(row) {
      const index = this.deleteBroadcast.indexOf(row)
      if (index > -1) {
        this.deleteBroadcast.splice(index, 1)
      }
    },
    /********** 删除指定广播-end ***********/

    /********** 添加广播-start ***********/
    // 打开添加广播弹框
    openAddBroadcastDialog() {
      this.broadcastData = {
        name: '',
        action: '',
        package_name: '',
        class_name: '',
        parameters: []
      }
      this.broadcastDialogVisible = true
      // this.$refs["addBroadcastForm"].clearValidate()
    },
    // 取消添加广播
    cancelAddBroadcast() {
      this.broadcastData = {
        name: '',
        action: '',
        package_name: '',
        class_name: '',
        parameters: []
      }
      this.broadcastDialogVisible = false
      this.$refs["addBroadcastForm"].clearValidate()
    },
    // 添加参数
    addParameter() {
      this.broadcastData.parameters.push({
        name: '',
        type: '',
        value: '',
        isEdit: true,
      })
    },
    // 删除参数
    removeParameter(index) {
      this.broadcastData.parameters.splice(index, 1)
    },
    // 编辑参数
    editParameter(data) {
      data.isEdit = true;
    },
    // 保存参数
    okParameter(data) {
      if (data.name != "") {
        data.isEdit = false;
      } else {
        this.$message.warning(this.$t("message.messageMsg.inputParameter"));
      }
    },
    // 保存添加广播
    saveAddBroadcast() {
      // 判断是否有正在编辑的参数
      if (this.broadcastData.parameters.some(param => param.isEdit)) {
        this.$message.warning(this.$t('message.messageMsg.complateEdit'))
        return
      }
      // 处理parameters数据，去掉isEdit字段
      const parameters = this.broadcastData.parameters.map(param => {
        const { name, type, value } = param
        return { name, type, value }
      })

      // 验证表单
      this.$refs['addBroadcastForm'].validate((valid) => {
        if (valid) {
          const newBroadcast = {
            name: this.broadcastData.name,
            action: this.broadcastData.action,
            package_name: this.broadcastData.package_name,
            class_name: this.broadcastData.class_name,
            parameters
          }

          // 添加到BroadcastInfo（数组格式）
          if (!this.s.BroadcastInfo) {
            this.s.BroadcastInfo = []
          }
          const existingIndex = this.s.BroadcastInfo.findIndex(b => b.name === newBroadcast.name)
          if (existingIndex > -1) {
            this.s.BroadcastInfo.splice(existingIndex, 1, newBroadcast)
          } else {
            this.s.BroadcastInfo.push(newBroadcast)
          }

          // 触发响应式更新
          this.$set(this.s, 'BroadcastInfo', [...this.s.BroadcastInfo])

          this.broadcastDialogVisible = false
          this.$message.success(this.$t('common.add_success'))
        }
      })
    },
    // 删除广播
    deleteAddBroadcast(index) {
      if (this.s.BroadcastInfo) {
        this.s.BroadcastInfo.splice(index, 1)
        // 触发响应式更新
        this.$set(this.s, 'BroadcastInfo', [...this.s.BroadcastInfo])
      }
    },
    /********** 添加广播-end ***********/
    
    /********** 添加按键映射-start ***********/
    // 打开添加按键映射弹框
    openAddKeyMappingDialog() {
      this.keyMappingData = {
        key: '',
        type: '',
        virtual_key: '',
        broadcast_name: '',
        package_name: '',
        class_name: ''
      }
      this.originalKey = ''
      this.targetKey = ''
      this.keyMappingDialogVisible = true
      // this.$refs["addKeyMappingForm"].clearValidate()
    },
    // 取消添加按键映射
    cancelAddKeyMapping() {
      this.keyMappingData = {
        key: '',
        type: '',
        virtual_key: '',
        broadcast_name: '',
        package_name: '',
        class_name: ''
      }
      this.originalKey = ''
      this.targetKey = ''
      this.keyMappingDialogVisible = false
      this.$refs["addKeyMappingForm"].clearValidate()
    },
    // 类型变化时重置字段
    onKeyMappingTypeChange(val) {
      if (val === 'NONE') {
        this.keyMappingData.virtual_key = ''
        this.keyMappingData.broadcast_name = ''
        this.keyMappingData.package_name = ''
        this.keyMappingData.class_name = ''
      } else if (val === 'BROADCAST') {
        this.keyMappingData.virtual_key = ''
        this.keyMappingData.package_name = ''
        this.keyMappingData.class_name = ''
      } else if (val === 'APPLICATION') {
        this.keyMappingData.virtual_key = ''
        this.keyMappingData.broadcast_name = ''
      } else if (val === 'OTHER_KEYCODE') {
        this.keyMappingData.broadcast_name = ''
        this.keyMappingData.package_name = ''
        this.keyMappingData.class_name = ''
      }
    },
    // 保存添加按键映射
    saveAddKeyMapping() {
      this.$refs['addKeyMappingForm'].validate((valid) => {
        if (valid) {
          const data = {
            key: this.keyMappingData.key,
            type: this.keyMappingData.type
          }

          if (this.keyMappingData.type === 'OTHER_KEYCODE') {
            data.virtual_key = this.keyMappingData.virtual_key
          }

          if (this.keyMappingData.type === 'BROADCAST') {
            data.broadcast_name = this.keyMappingData.broadcast_name
          }

          if (this.keyMappingData.type === 'APPLICATION') {
            data.package_name = this.keyMappingData.package_name
            data.class_name = this.keyMappingData.class_name
          }

          if (!this.s.KeyMappingInfo) {
            this.s.KeyMappingInfo = []
          }
          const existingIndex = this.s.KeyMappingInfo.findIndex(k => k.key === data.key)
          if (existingIndex > -1) {
            this.s.KeyMappingInfo.splice(existingIndex, 1, data)
          } else {
            this.s.KeyMappingInfo.push(data)
          }

          // 触发响应式更新
          this.$set(this.s, 'KeyMappingInfo', [...this.s.KeyMappingInfo])

          this.keyMappingDialogVisible = false
          this.$message.success(this.$t('common.add_success'))
        }
      })
    },
    // 删除按键映射
    handleKeyMappingDelete(index) {
      if (this.s.KeyMappingInfo) {
        this.s.KeyMappingInfo.splice(index, 1)
        // 触发响应式更新
        this.$set(this.s, 'KeyMappingInfo', [...this.s.KeyMappingInfo])
      }
    },
    /********** 添加按键映射-end ***********/
  }
}
</script>

<style lang="less" scoped>
.parameter-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.parameter-item .el-form-item {
  margin-bottom: 0;
  flex: 1;
}

.input-width-select {
  /deep/ .el-select {
    width: 200px;
  }
  /deep/ .el-input-group__prepend {
    background-color: #ffffff !important;
  }
}
</style>
